import { render } from "./ModalAddEditCoupon.vue?vue&type=template&id=5a38be33"
import script from "./ModalAddEditCoupon.vue?vue&type=script&lang=js"
export * from "./ModalAddEditCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__